module.exports = __webpack_public_path__ + "img/one_6.d0e27c6e.png";